<template>
  <div>
    <Input
      label="detail.stash.username"
      v-model="form.username"
      :state="stateUsername()"
      :errorMessage="validateUsername()"
      disableSpecialCharacters="true"
    />

    <Input
      label="global.password"
      v-model="form.password"
      :state="validateState('password')"
      :errorMessage="validatePassword()"
    />

    <TabMenu @changeTab="changeTab">
      <TabItem name="forms.vm.catalogTitle" :selected="!showCodeForm">
        <b-form-group
          :label="$t('forms.vm.catalog')"
          :state="validateState('catalog')"
        >
          <multiselect
            v-model="form.catalog"
            :options="catalogList"
            track-by="id"
            label="name"
            :loading="loadingCatalog"
            :allowEmpty="false"
            :show-labels="false"
            :searchable="true"
            :placeholder="$t('forms.vm.catalog')"
            :show-no-results="true"
          />

          <a
            href="javascript:;"
            class="select-from-link"
            @click="openSecondModal"
            >{{ $t('global.selectFromList') }}</a
          >
        </b-form-group>

        <ProductCatalogPriceInfo
          v-if="form.catalog"
          :selectedCatalog="form.catalog"
          :selectedCatalogDayCount="selectedDayCount"
          product="stash"
          class="mt-10"
        ></ProductCatalogPriceInfo>
      </TabItem>
      <TabItem
        name="giftcode.useGiftCode"
        :selected="showCodeForm"
        :disabled="loading"
      >
        <Input
          label="giftcode.giftcode"
          v-model="formgift.gift_code"
          :defaultValue="formgift.gift_code"
          class="mb-0"
          :state="codeIsValid"
        />
        <a
          href="javascript:;"
          class="select-from-link"
          @click="checkEnteredCode"
          >{{ $t('giftcode.checkCode') }}</a
        >

        <InfoBox v-if="checkCode && checkCode.is_used" class="mt-3">{{
          $t('giftcode.codeUsedBefore')
        }}</InfoBox>

        <div
          class="product-catalog-total-info justify-content-start mt-3"
          v-if="checkCode && codeIsValid"
        >
          <div class="product-catalog-total-info-content w-100 mw-100">
            <div class="item">
              <div class="name">{{ $t('giftcode.product') }}:</div>
              <div class="result">
                <div>
                  {{
                    checkCode.productCatalog && checkCode.productCatalog.data
                      ? checkCode.productCatalog.data.name
                      : '-'
                  }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="name">{{ $t('giftcode.discount') }}:</div>
              <div class="result">
                <div>
                  {{
                    checkCode.gift_value +
                    ' ' +
                    (checkCode.gift_mode == 'percentage'
                      ? '%'
                      : checkCode.gift_mode)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </TabItem>
    </TabMenu>

    <SecondModal
      title="global.selectProductCatalogList"
      :show="showSecondModal"
      @closeSecondModal="closeSecondModal()"
    >
      <ProductCatalog
        :showMonthButton="`${false}`"
        :show1YearButton="`${false}`"
        :show3YearButton="`${false}`"
        :productId="serviceProductId"
        @selectedItem="selectedProductCatalog"
        @closeSecondModal="closeSecondModal()"
      />
    </SecondModal>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'StashUserForm',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    closeSecondModalProps: Boolean,
    serviceProductId: '',
    accountId: '',
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        catalog: '',
      },
      formgift: {
        gift_code:
          this.$route.query && this.$route.query.code
            ? this.$route.query.code
            : '',
      },
      catalogList: [],
      loading: false,
      loadingCatalog: false,
      showSecondModal: false,
      selectedDayCount: '30',
      checkCode: '',
      codeIsValid: undefined,
      showCodeForm: this.$route.query && this.$route.query.code ? true : false,
      userNameExist: false,
    }
  },
  validations: {
    form: {
      catalog: {
        required,
      },
      username: {
        required,
        minLength: minLength(3),
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  created() {
    this.getProductCatalogs()
  },
  methods: {
    stateUsername() {
      if (this.userNameExist == true) return false

      return this.validateState('username')
    },
    validateUsername() {
      if (this.form.username) {
        if (this.form.username.length < 3)
          return this.$t('errors.minLenght').replace('{0}', 3)
        else if (this.userNameExist == true)
          return this.$t('detail.stash.chooseAnotherUsername')
      } else return this.$t('errors.notEmpty')
    },
    validatePassword() {
      if (this.form.password) {
        if (this.form.password.length < 3)
          return this.$t('errors.minLenght').replace('{0}', 3)
      } else return this.$t('errors.notEmpty')
    },
    changeTab(tab) {
      this.showCodeForm = tab == 'giftcode.useGiftCode'
    },
    // Product catalog begin
    getProductCatalogs() {
      this.form.catalog = ''
      if (this.serviceProductId) {
        this.getProductCatalogList()
          .then((res) => {
            this.setProductCatalogList(res)
          })
          .catch(() => {
            this.catalogList = []
          })
      } else this.catalogList = []
    },
    getProductCatalogList() {
      this.loadingCatalog = true
      return new Promise((resolve, reject) => {
        ApiService.get(
          `marketplace/${this.serviceProductId}/catalogs?page=1&start=0&limit=25&position=id|desc`
        )
          .then(({ data }) => {
            resolve(data)
            this.loadingCatalog = false
          })
          .catch((err) => {
            reject(err)
            this.loadingCatalog = false
          })
      })
    },
    setProductCatalogList(res) {
      if (res && res.data && res.data.length > 0) {
        this.catalogList = res.data
        if (res.data.length == 1) this.form.catalog = this.catalogList[0]
      }
    },
    // Product catalog end
    marketplaceChange() {
      this.catalogList = []

      if (this.form.marketplace.id && this.form.marketplace.id != '') {
        this.getProductCatalogs()
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.controlUsername()
    },
    controlUsername() {
      if (this.form.username) {
        ApiService.get(`stash/user/exists?username=${this.form.username}`)
          .then(({ data }) => {
            this.userNameExist = data.exists
          })
          .catch((err) => {
            this.userNameExist = true
          })
          .finally(() => {
            if (!this.showCodeForm) {
              this.$v.form.$touch()
              if (this.$v.form.$anyError || this.userNameExist) {
                this.$emit('resetDetailForm', false)
                return
              }
            }
            this.controlCode()
          })
      } else {
        if (!this.showCodeForm) {
          this.$v.form.$touch()
          if (this.$v.form.$anyError || this.userNameExist) {
            this.$emit('resetDetailForm', false)
            return
          }
        }
        this.controlCode()
      }
    },
    checkEnteredCode() {
      if (this.formgift.gift_code) {
        this.loading = true
        this.checkCode = ''
        this.codeIsValid = undefined
        ApiService.get(
          `/core/gift-codes/code-exists?code=${this.formgift.gift_code}&include=productCatalog`
        )
          .then(({ data }) => {
            this.loading = false
            if (data.data.is_used) {
              // this.$generateToast(
              //   this,
              //   'danger',
              //   this.$t('giftcode.codeUsedBefore'),
              //   true
              // )
              this.checkCode = data.data
              this.codeIsValid = false
            } else {
              this.checkCode = data.data
              this.codeIsValid = true
            }
          })
          .catch((data) => {
            this.$generateToast(
              this,
              'danger',
              this.$t('giftcode.notFound'),
              true
            )
            this.loading = false
            this.codeIsValid = false
          })
      } else {
        this.codeIsValid = false
      }
    },
    controlCode() {
      this.codeIsValid = undefined
      if (!this.showCodeForm) this.saveStash()
      else {
        if (!this.formgift.gift_code) {
          this.codeIsValid = false
          this.$emit('resetDetailForm', false)
        } else {
          ApiService.get(
            `/core/gift-codes/code-exists?code=${this.formgift.gift_code}&include=productCatalog`
          )
            .then(({ data }) => {
              if (data.data.is_used) {
                this.$generateToast(
                  this,
                  'danger',
                  this.$t('giftcode.codeUsedBefore'),
                  true
                )
                this.codeIsValid = false

                this.$emit('resetDetailForm', false)
              } else {
                this.codeIsValid = true
                this.saveStash()
              }
            })
            .catch((data) => {
              this.$generateToast(
                this,
                'danger',
                this.$t('giftcode.notFound'),
                true
              )
              this.codeIsValid = false
              this.$emit('resetDetailForm', false)
            })
        }
      }
    },
    saveStash() {
      let params = {
        account_id: this.accountId,
        catalog_id: this.form.catalog.id,
        username: this.form.username,
        password: this.form.password,
      }

      if (this.showCodeForm) {
        params.catalog_id = this.checkCode.product_catalog_id
        params.gift_code = this.formgift.gift_code
      }

      ApiService.post(`/stash/users`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.checkCode = ''
          this.showCodeForm = undefined
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    selectedProductCatalog(item, dayCount) {
      this.form.catalog = item
      this.selectedDayCount = dayCount
    },
    openSecondModal() {
      this.showSecondModal = true
    },
    closeSecondModal() {
      this.showSecondModal = false
    },
  },
  components: {
    ProductCatalog: () => import('@/components/ProductCatalog'),
    ProductCatalogPriceInfo: () =>
      import('@/components/ProductCatalogPriceInfo'),
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    closeSecondModalProps() {
      this.showSecondModal = false
      this.checkCode = ''
      this.codeIsValid = undefined
      this.showCodeForm = false
    },
    serviceProductId() {
      this.getProductCatalogs()
    },
  },
}
</script>
